<template>
  <form
    :action="url"
    method="post"
    target="_blank"
  >
    <input type="text" hidden name="id_usuario" :value="id_usuario" />
    <input type="text" hidden name="id_unico_preferencia" :value="props.filtros.id_unico_preferencia" />
    <input type="text" hidden name="exportacao_relatorio_excel" value="S" />
    <input type="text" hidden name="apenas_pedidos_faturados" :value="props.filtros.apenas_pedidos_faturados" />
    <input type="text" hidden name="apenas_qtde_pendente_maior_que_zero" :value="props.filtros.apenas_qtde_pendente_maior_que_zero" />
    <input type="text" hidden name="grupos" :value="props.filtros.grupos" />
    <input type="text" hidden name="filiais" :value="props.filtros.filiais" />
    <input type="text" hidden name="segmentos" :value="props.filtros.segmentos" />
    <input type="text" hidden name="compradores" :value="props.filtros.compradores" />
    <input type="text" hidden name="fornecedores" :value="props.filtros.fornecedores" />
    <input type="text" hidden name="histogramas" :value="JSON.stringify(props.filtros.histogramas)" />

    <SysBtn
      type="submit"
      class="ml-3"
    >
      <v-icon left>$Excel</v-icon>
      Exportar
    </SysBtn>
  </form>
</template>

<script setup>
import $axios from "@/api/api.js";

const url = $axios.defaults.baseURL + '/relatorios/dashboard/pedidos-pendentes/exportar-relatorio-excel';
const id_usuario = localStorage.getItem('id');
const props = defineProps({
  filtros: { type: Object, required: true }
});
</script>
